export { default as PageDescription } from './PageDescription';
export type { Props as PageDescriptionProps } from './PageDescription';
